import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const deductionListService = (params: Types.DeductionListRequest) =>
  RestAPIClient.call<Types.DeductionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const deductionListShortService = (params: Types.DeductionListRequest) =>
  RestAPIClient.call<Types.DeductionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
      byPassError: true,
    },
  });

export const deductionCreateService = (params: Types.DeductionCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const deductionUpdateService = (params: Types.DeductionUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const deductionDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const deductionDetailService = (id: string) =>
  RestAPIClient.call<Types.DeductionDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
